import React from "react";
import { Spin } from "antd";

const Loader = () => {
	return (
		<div
			style={{
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				background:'rgba(0,0,0,0.2)',
				zIndex:1,
				height:'100vh',
				width:'100vw',
				position:'absolute'
			}}
		>
			<Spin size="large" />
		</div>
	);
};

export default Loader;
